import { useState } from "react";
import NotificationError from "../../../../helpers/errors_notifications/NotificationError";
import ArzfiBankAccount from "./ArzfiBankAccounts";
import styles from "./BankIncrease.module.scss";
import { bankPaymentIncrease } from "../../../../services/adminServices";
// import { DatePicker } from "jalali-react-datepicker";
import { DatePicker } from "jalali-react-datepicker";
import { errorMessage, successMessage } from "../../../../utils/messages";
import Num2persian from "num2persian";
export default function BankIncrease() {
  const [showAccountInformation, setShowAccountInformation] = useState(false);
  const [depositPic, setDepositPic] = useState("");
  const [amount, setAmount] = useState("");
  const [transId, setTransId] = useState("");
  const [deactivatedBtn, setDeactivatedBtn] = useState(false);
  const handleSendBankDataIncrease = async (e) => {
    e.preventDefault();
    if (!amount) return errorMessage("مبلغ پرداخت را وارد کنید");
    if (!transId) return errorMessage("شماره پیگیری را وارد کنید");
    if (!depositPic) return errorMessage("تصویر فیش را ارسال کنید");
    try {
      setDeactivatedBtn(true);
      const formData = new FormData();
      formData.append("amount", amount);
      formData.append("transId", transId);
      formData.append("date", document.querySelector(".datePickerBank").value);
      formData.append("file", depositPic);
      const { data } = await bankPaymentIncrease(formData);
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          successMessage(data.message);
          setAmount("");
          setTransId("");
          setDepositPic("");
        }
      }
    } catch {
      errorMessage("خطایی رخ داده دوباره تلاش کنید");
    } finally {
      setDeactivatedBtn(false);
    }
  };
  return (
    <>
      <ArzfiBankAccount
        showDetail={showAccountInformation}
        setDetail={setShowAccountInformation}
      />
      <div className={styles.container}>
        <div
          className={styles.AccountsInfo_BTN}
          onClick={() => setShowAccountInformation(true)}
        >
          اطلاعات حساب ها
        </div>
        <div style={{ marginBottom: "6px" }}>
          <NotificationError
            bgBorder="#F65555"
            fontColor="rgba(246, 85, 85, 1)"
            bgColor="rgba(246, 85, 85, 0.20)"
            text="پس از واریز مبلغ به یکی از حساب ها اطلاعات فرم زیر را تکمیل کنید."
          />
        </div>
        <div>
          <NotificationError
            bgBorder="rgba(44, 64, 101, 1)"
            fontColor="rgba(44, 64, 101, 1)"
            bgColor="rgba(44, 64, 101, 0.2)"
            text="در صورت واریز پایا پس از دریافت وجه حساب کاربری شارژ خواهد شد."
          />
        </div>
        <div className={styles.input_container}>
          <form onSubmit={(e) => handleSendBankDataIncrease(e)}>
            <input
              className="changeBackgroundToWhite changeFontColorToBlack"
              type="number"
              placeholder="مبلغ واریز(تومان)"
              onChange={(e) => setAmount(e.target.value)}
              value={amount}
            />
            <div className={styles.persian_price}>
              {amount ? Num2persian(amount) + " تومان" : ""}
            </div>
            <input
              className="changeBackgroundToWhite changeFontColorToBlack"
              type="text"
              placeholder="شماره پیگیری"
              onChange={(e) => setTransId(e.target.value)}
              value={transId}
            />
            <div className={styles.dateTime_pic_container}>
              <div className={`${styles.date_and_time}`}>
                <DatePicker
                  label="تاریخ واریز"
                  className="datePickerBank changeBackgroundToWhite changeFontColorToBlack"
                />
              </div>
              <label htmlFor="depositPicUpload">
                <div className={styles.upload_pic}>انتخاب تصویر فیش واریزی</div>
                <input
                  accept="image/*"
                  type="file"
                  id="depositPicUpload"
                  style={{ display: "none" }}
                  onChange={(e) => setDepositPic(e.target.files[0])}
                />
              </label>
            </div>
            {depositPic ? (
              <div className={styles.pic_information}>
                <div>{depositPic.name}</div>
                {!deactivatedBtn && (
                  <div onClick={() => setDepositPic("")}>حدف تصویر</div>
                )}
              </div>
            ) : (
              ""
            )}
            <div className={styles.btn_place}>
              <button
                type="submit"
                className={styles.submit_btn}
                disabled={deactivatedBtn}
              >
                ثبت
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
